/* Dukier Back-in-Stock — muestra "Avisame" cuando la variante seleccionada
   esta agotada; modal con selector de variante + email; envia al App Proxy. */
(function () {
  "use strict";

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var ENDPOINT = "/apps/back-in-stock/subscribe";

  // Los textos vienen YA traducidos por Shopify desde locales/*.json (clave
  // back_in_stock.js.*), inyectados por el snippet en <script data-bis-i18n>.
  // Una sola fuente de verdad; aquí solo leemos la clave con fallback.
  function t(i18n, key) { return (i18n && i18n[key]) || key; }

  function pageVariantId(root) {
    // 1. URL ?variant= — este theme actualiza la URL al cambiar de talla (lo mas fiable).
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    if (m) return m[1];
    // 2. [name=id] en CUALQUIER parte del documento. En este theme el <select> de
    //    variante esta FUERA del <form> de carrito, por eso buscarlo solo dentro fallaba.
    var input = document.querySelector("form [name='id'], [name='id']");
    if (input && input.value) return String(input.value);
    return null;
  }

  function setupRoot(root) {
    if (root.dataset.bisInit) return; // evita doble init (re-render de seccion del theme) -> timers/listeners duplicados
    root.dataset.bisInit = "1";
    var variants = [];
    try { variants = JSON.parse(root.querySelector("[data-bis-variants]").textContent); }
    catch (e) { console.warn("[bis] data-bis-variants invalido:", e); return; }
    var byId = {};
    variants.forEach(function (v) { byId[String(v.id)] = v; });

    var trigger = root.querySelector("[data-bis-trigger]");
    var modal = root.querySelector("[data-bis-modal]");
    var form = root.querySelector("[data-bis-form]");
    var feedback = root.querySelector("[data-bis-feedback]");
    var select = root.querySelector("[data-bis-variant-select]");
    var locale = root.getAttribute("data-bis-locale") || "es-ES";

    // Resuelve la variante seleccionada de forma robusta: 1) por id (URL/[name=id]),
    // 2) por opcion marcada (talla) casando el titulo de variante, 3) primera variante.
    function variantByCheckedOption() {
      var checked = document.querySelectorAll("input[type='radio']:checked");
      for (var i = 0; i < checked.length; i++) {
        var val = String(checked[i].value || "").toLowerCase().trim();
        if (!val) continue;
        for (var j = 0; j < variants.length; j++) {
          if (String(variants[j].title || "").toLowerCase().trim() === val) return variants[j];
        }
      }
      return null;
    }
    function currentVariant() {
      var vid = pageVariantId(root);
      var v = vid ? byId[vid] : null;
      if (!v) v = variantByCheckedOption();
      if (!v && variants.length) v = variants[0];
      return v;
    }
    // Muestra el trigger solo si la variante seleccionada en pagina esta agotada.
    function updateTrigger() {
      var v = currentVariant();
      root.hidden = !(v && v.available === false);
      if (!root.hidden && v) root.setAttribute("data-bis-variant-id", v.id);
    }

    function selectedVariantId() {
      if (select && select.value) return select.value;
      var v = currentVariant();
      return (v && String(v.id)) || root.getAttribute("data-bis-variant-id") || pageVariantId(root);
    }

    if (trigger) trigger.addEventListener("click", function () {
      // Sincroniza el selector del modal con la variante elegida en pagina.
      var pv = pageVariantId(root);
      if (select && pv) {
        for (var i = 0; i < select.options.length; i++) {
          if (select.options[i].value === pv) { select.selectedIndex = i; break; }
        }
      }
      if (feedback) { feedback.textContent = ""; feedback.removeAttribute("data-kind"); }
      if (modal.showModal) modal.showModal(); else modal.setAttribute("open", "");
    });

    var closeBtn = root.querySelector("[data-bis-close]");
    if (closeBtn) closeBtn.addEventListener("click", function () {
      if (modal.close) modal.close(); else modal.removeAttribute("open");
    });
    // Click en backdrop cierra
    if (modal) modal.addEventListener("click", function (e) {
      if (e.target === modal && modal.close) modal.close();
    });

    var submitBtn = root.querySelector("[data-bis-submit]");
    if (submitBtn) submitBtn.addEventListener("click", function (e) {
      e.preventDefault();
      submit(root, form, feedback, locale, selectedVariantId());
    });
    // Enter en el email tambien envia (ya no hay <form> que lo haga)
    var emailInput = root.querySelector("[data-bis-email]");
    if (emailInput) emailInput.addEventListener("keydown", function (e) {
      if (e.key === "Enter") { e.preventDefault(); submit(root, form, feedback, locale, selectedVariantId()); }
    });

    updateTrigger();
    // Eventos: input id, o cualquier radio/select de opciones (talla), + eventos custom + popstate.
    document.addEventListener("change", function (e) {
      if (!e.target) return;
      if (e.target.name === "id" || e.target.type === "radio" || e.target.tagName === "SELECT") updateTrigger();
    });
    document.addEventListener("variant:change", updateTrigger);
    document.addEventListener("variant:changed", updateTrigger);
    window.addEventListener("popstate", updateTrigger);
    // Red de seguridad: hay themes que cambian de variante sin disparar ningun evento
    // que capturemos (botones de talla + pushState de la URL, sin recarga). Sondeamos
    // la variante seleccionada y re-evaluamos solo si cambia. ~400ms, coste minimo.
    var bisLastSig = null;
    setInterval(function () {
      var v = currentVariant();
      var sig = v ? String(v.id) : "";
      if (sig !== bisLastSig) { bisLastSig = sig; updateTrigger(); }
    }, 400);
  }

  function submit(root, form, feedback, locale, variantId) {
    var emailEl = form.querySelector("[data-bis-email]");
    var submitBtn = form.querySelector("[data-bis-submit]");
    var email = (emailEl.value || "").trim().toLowerCase();
    var i18n = {};
    try { i18n = JSON.parse(root.querySelector("[data-bis-i18n]").textContent); } catch (e) {}
    function show(kind, msg) { feedback.textContent = msg; feedback.setAttribute("data-kind", kind); }

    if (!email) { show("error", t(i18n,"missing_fields")); return; }
    if (!EMAIL_RE.test(email) || email.length > 254) { show("error", t(i18n,"invalid_email")); return; }
    if (!variantId) { show("error", t(i18n,"variant_not_found")); return; }

    submitBtn.disabled = true;
    show("info", t(i18n,"sending"));

    fetch(ENDPOINT, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ variant_id: Number(variantId), email: email, accepts_marketing: true, locale: locale })
    })
      .then(function (r) { return r.json().then(function (d) { return { s: r.status, d: d }; }); })
      .then(function (res) {
        if (res.d && res.d.ok) { show("success", t(i18n,"ok")); emailEl.value = ""; }
        else { show("error", t(i18n,(res.d && res.d.error) || "unknown")); }
      })
      .catch(function () { show("error", t(i18n,"unknown")); })
      .finally(function () { submitBtn.disabled = false; });
  }

  function init() {
    var roots = document.querySelectorAll("[data-bis-root]");
    for (var i = 0; i < roots.length; i++) setupRoot(roots[i]);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
